import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterModule, Routes } from '@angular/router';
import { DotCMSEditablePageService } from '@dotcms/angular';
import { DotCMSClientConfig } from '@dotcms/types';
import { filter, firstValueFrom, race, switchMap, tap, timer } from 'rxjs';
import { ConfigService } from 'src/app/extensions/dot-cms-uve/services/dot-cms-uve-config/dot-cms-config.service';

import { DotCmsBlogDetailComponent } from '../content-types/dot-cms-uve-blog/dot-cms-uve-blog-detail/dot-cms-uve-blog-detail.component';
import { DotCmsUveFacade } from '../facades/dot-cms-uve.facade';

const routes: Routes = [{ path: 'page/blog/post/:slug', component: DotCmsBlogDetailComponent }];

export function initializeApp(configService: ConfigService) {
  return async () => {
    try {
      const config = await firstValueFrom(configService.loadConfig());
      configService.setConfig(config);
    } catch (error) {
      throw error;
    }
  };
}
@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [
    DotCMSEditablePageService,
    provideAppInitializer(() => {
      const configService = inject(ConfigService);
      const dotCmsUveFacade = inject(DotCmsUveFacade);
      const pageState$ = toObservable(dotCmsUveFacade.pageState);

      return firstValueFrom(
        configService.loadConfig().pipe(
          tap((config: DotCMSClientConfig) => {
            configService.setConfig(config);
          }),
          switchMap(() =>
            race(
              pageState$.pipe(filter(state => !!state?.pageResponse)),
              timer(5000).pipe(tap(() => console.warn('PageState timeout, continuing bootstrap')))
            )
          )
        )
      );
    }),
  ],
})
export class DotCmsUveRoutingModule {}
